module.exports = __webpack_public_path__ + "img/virus.c0769a0.webp";